import { useKratosSession } from "@saflib/ory-kratos-sdk";
import { useListListedParts, useGetOrganization } from "@vendata/power-up-sdk";

/**
 * MyPortal pulls the listed-parts feed that My Listings also use —
 * the table view just renders more columns from each row.
 *
 * We also fetch the current user's organization so the "Organization" column
 * can show the seller's company name. The listed-parts endpoint strips
 * `org_id` from each row (non-admin shape), but every row is implicitly owned
 * by the caller's organization, so a single lookup is enough.
 */
export function useMyPortalLoader() {
  return {
    sessionQuery: useKratosSession(),
    listedPartsQuery: useListListedParts(),
    organizationQuery: useGetOrganization(),
  };
}
